import Siema from 'siema';

const slider = () => {
  const siema = new Siema({
    selector: '.js-testimonials',
    perPage: window.matchMedia('(min-width: 768px)').matches ? 2 : 1,
  });

  window.addEventListener('keydown', e => {
    if(e.keyCode == 37) {
      siema.prev();
    } else if (e.keyCode == 39) {
      siema.next();
    }
  });

  document.querySelector('.c-testimonials__prev').addEventListener('click', () => siema.prev());
  document.querySelector('.c-testimonials__next').addEventListener('click', () => siema.next());
};

export default slider;



// WEBPACK FOOTER //
// ./scripts/modules/slider.js